import { tickerItems } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[620px] w-full flex-col overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20newsroom%20panorama%20at%20night%20filled%20with%20smoke%20and%20warm%20crimson%20amber%20spotlights%2C%20silhouettes%20of%20broadcast%20desks%20and%20light%20rigs%20fading%20into%20black%20haze%2C%20abstract%20editorial%20breaking-news%20aesthetic%2C%20deep%20red%20and%20gold%20glow%20against%20near%20black%20background%2C%20cinematic%20film%20grain%2C%20high%20contrast%2C%20atmospheric%20and%20intense&width=1800&height=1100&seq=hero-main-2026&orientation=landscape"
          alt="黑料王 压轴高能劲爆内容"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/55 to-background-950" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-4 pb-10 pt-28 md:px-6 md:pt-32">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-accent-400/40 bg-accent-500/15 px-3 py-1 text-xs font-semibold text-accent-200">
            <i className="ri-flashlight-fill animate-flame" />
            今晚 22:00 压轴档首发
          </span>
          <span className="hidden items-center gap-1.5 rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 text-xs font-medium text-background-200 sm:inline-flex">
            <i className="ri-megaphone-line" />
            顶配高能名场面持续更新中
          </span>
        </div>

        <h1 className="mt-6 max-w-4xl font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
          黑料王猛料、大瓜
          <br className="hidden md:block" />
          压轴高能<span className="text-accent-400">劲爆</span>一次看够
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          一手猛料、实时大瓜与高能复盘在此聚合。从录音标注到后台动线，
          从辟谣声明到串瓜名场面，黑料王把每一段劲爆细节拆给你看。
        </p>

        <form
          className="mt-8 flex w-full max-w-2xl flex-col gap-2 sm:flex-row"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-background-300" />
            <input
              type="text"
              placeholder="搜个瓜名、人名或关键词…"
              className="h-12 w-full rounded-md border border-background-50/15 bg-background-950/60 pl-12 pr-4 text-sm text-background-50 outline-none backdrop-blur placeholder:text-background-300 focus:border-accent-400"
            />
          </div>
          <button
            type="submit"
            className="h-12 whitespace-nowrap cursor-pointer rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            搜猛料
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center gap-2 text-xs text-background-200/80">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-fire-fill" />
          </span>
          <span>今日高能榜</span>
          {['大瓜速递 98°', '录音逐句版 94°', '串瓜现场 90°', '压轴复盘 86°'].map((hot) => (
            <span
              key={hot}
              className="whitespace-nowrap rounded-full border border-background-50/15 bg-background-50/5 px-3 py-1.5"
            >
              {hot}
            </span>
          ))}
        </div>
      </div>

      {/* 滚动话题带 */}
      <div className="relative z-10 border-t border-background-50/10 bg-background-950/70 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center px-4 md:px-6">
          <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-500 py-3 pr-4 text-background-50">
            <i className="ri-flashlight-line text-lg" />
            <span className="whitespace-nowrap text-sm font-bold">即时瓜点</span>
          </div>
          <div className="relative flex-1 overflow-hidden py-3">
            <div className="animate-ticker flex w-max items-center gap-10 whitespace-nowrap pl-4">
              {[...tickerItems, ...tickerItems].map((item, idx) => (
                <span key={idx} className="flex items-center gap-3 text-sm text-background-100/85">
                  <i className="ri-record-circle-line text-accent-400" />
                  {item}
                </span>
              ))}
            </div>
          </div>
          <a
            href="#timeline"
            className="z-10 hidden shrink-0 cursor-pointer items-center gap-1.5 border-l border-background-50/10 px-3 py-3 text-sm font-medium text-accent-300 hover:text-accent-200 sm:flex"
          >
            看时间轴 <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}